import { ROLE_TYPES } from "../../../constants/roles";

export const rolesWithPrivileges = [
	{
		role: ROLE_TYPES.ER_USER,
		allowWcnMapping: false,
		privileges: ["view_portcodes"],
	},
	{
		role: ROLE_TYPES.ER_CLIENT,
		allowWcnMapping: true,
		privileges: [
			"view_portcodes",
			"create_enrollvessel",
			"view_enrollvessel",
			"update_enrollvessel",
			"delete_enrollvessel",
			"delete_parent_report",
			"import_vessels",
			"submit_to_abs",
			"show_import_additional_data",
		],
	},
	{
		role: ROLE_TYPES.ER_REVIEWER,
		allowWcnMapping: false,
		privileges: [
			"view_portcodes",
			"create_enrollvessel",
			"view_enrollvessel",
			"update_enrollvessel",
			"delete_enrollvessel",
			"import_vessels",
			"export_vessels",
			"submit_to_abs",
			"submit_to_verifier",
			"show_verification_tab",
			"claim_btn",
			"view_Calculated_diff_Materiality",
			"available_for_client_check",
			"showNotifications"
		],
	},
	{
		role: ROLE_TYPES.ER_VERIFIER,
		allowWcnMapping: false,
		privileges: [
			"view_portcodes",
			"create_enrollvessel",
			"view_enrollvessel",
			"update_enrollvessel",
			"delete_enrollvessel",
			"import_vessels",
			"export_vessels",
			"submit_to_abs",
			"view_verification_update",
			"view_verification_reject",
			"view_verification_complete",
			"show_verification_tab",
			"view_Calculated_diff_Materiality",
			"available_for_client_check",
			"showNotifications",
		],
	},
	{
		role: ROLE_TYPES.ER_SUPERADMIN,
		allowWcnMapping: false,
		privileges: [
			"view_portcodes",
			"create_enrollvessel",
			"view_enrollvessel",
			"update_enrollvessel",
			"delete_enrollvessel",
			"import_vessels",
			"export_vessels",
			"view_adminmenu",
			"submit_to_abs",
			"report_submitted_to_abs",
			"show_verification_tab",
			"show_import_additional_data",
			"delete_parent_report",
			"view_Calculated_diff_Materiality",
			"available_for_client_check",
			"delete_document",
			"showNotifications",
		],
	},
	{
		role: ROLE_TYPES.ER_ADMIN,
		allowWcnMapping: false,
		privileges: [
			"view_portcodes",
			"create_enrollvessel",
			"view_enrollvessel",
			"update_enrollvessel",
			"delete_enrollvessel",
			"import_vessels",
			"export_vessels",
			"view_adminmenu",
			"show_verification_tab",
			"view_Calculated_diff_Materiality",
			"showNotifications",
		],
	},
	{
		role: ROLE_TYPES.ER_PORTCODEADMIN,
		allowWcnMapping: false,
		privileges: [
			"create_portcodes",
			"edit_portcodes",
			"delete_portcodes",
			"view_portcodes",
			"import_portcodes",
			"export_portcodes",
			"show_verification_tab",
			"view_Calculated_diff_Materiality",
			"showNotifications",
		],
	},
	{
		role: ROLE_TYPES.ER_ABSTESTER,
		allowWcnMapping: false,
		privileges: [
			"create_portcodes",
			"edit_portcodes",
			"delete_portcodes",
			"view_portcodes",
			"import_portcodes",
			"export_portcodes",
			"create_enrollvessel",
			"view_enrollvessel",
			"update_enrollvessel",
			"delete_enrollvessel",
			"view_adminmenu",
			"import_vessels",
			"show_verification_tab",
			"view_Calculated_diff_Materiality",
			"available_for_client_check",
			"showNotifications",
		],
	},
];
